import React from 'react';
import { useTranslation } from 'react-i18next';

export default function NatalFormActions({
  actionsRef,
  loadingSave,
  loadingChart,
  disabled = false,
  onSave,
}) {
  const { t } = useTranslation('natal');
  const isLoading = loadingSave || loadingChart || disabled;

  return (
    <div
      ref={actionsRef}
      className="natal-form-actions"
    >
      <button
        type="button"
        onClick={onSave}
        disabled={isLoading}
        className="natal-primary-action"
      >
        {isLoading
          ? (disabled && !loadingSave && !loadingChart ? 'Confirmando zona horaria…' : t('calculating'))
          : t('saveAndView')}
      </button>
    </div>
  );
}
